module.exports = __webpack_public_path__ + "img/familybook_logo.8a4cd231.svg";